export interface CypherTemplate {
  id: string;
  name: string;
  description: string;
  cypher: string;
  params: Array<{
    name: string;
    label: string;
    placeholder: string;
    type: 'text' | 'number' | 'node_label' | 'edge_type' | 'node_name';
  }>;
}

export const CYPHER_TEMPLATES: CypherTemplate[] = [
  {
    id: 'find-by-name',
    name: 'Find Entity by Name',
    description: 'Search for nodes whose name contains the given text',
    cypher: 'MATCH (n) WHERE n.name CONTAINS $name RETURN n',
    params: [{ name: 'name', label: 'Name', placeholder: 'e.g., Viktor', type: 'node_name' }],
  },
  {
    id: 'all-paths',
    name: 'All Paths Between Two Entities',
    description: 'Find the shortest path between two named entities (max 5 hops)',
    cypher: 'MATCH path = shortestPath((a {name: $from})-[*..5]-(b {name: $to})) RETURN path',
    params: [
      { name: 'from', label: 'From Entity', placeholder: 'e.g., Viktor Petrov', type: 'node_name' },
      { name: 'to', label: 'To Entity', placeholder: 'e.g., 14 Kensington Palace Gardens', type: 'node_name' },
    ],
  },
  {
    id: 'neighbors',
    name: 'Neighbors at Depth',
    description: 'Find all entities connected to a named entity within N hops',
    cypher: 'MATCH path = (n {name: $name})-[*1..$depth]-(m) UNWIND nodes(path) AS node UNWIND relationships(path) AS r RETURN DISTINCT node, r',
    params: [
      { name: 'name', label: 'Entity Name', placeholder: 'e.g., Viktor Petrov', type: 'node_name' },
      { name: 'depth', label: 'Depth', placeholder: '2', type: 'number' },
    ],
  },
  {
    id: 'by-jurisdiction',
    name: 'Entities by Jurisdiction',
    description: 'Find all entities in a specific jurisdiction',
    cypher: 'MATCH (n) WHERE n.jurisdiction = $jurisdiction RETURN n',
    params: [{ name: 'jurisdiction', label: 'Jurisdiction', placeholder: 'e.g., Cyprus', type: 'text' }],
  },
  {
    id: 'by-type',
    name: 'Entities by Type',
    description: 'Find all entities of a specific type (label)',
    cypher: 'MATCH (n:$label) RETURN n',
    params: [{ name: 'label', label: 'Entity Type', placeholder: 'e.g., Company', type: 'node_label' }],
  },
  {
    id: 'ownership-chain',
    name: 'Ownership Chain',
    description: 'Trace beneficial ownership and shareholder relationships from an entity',
    cypher: 'MATCH path = (n {name: $name})-[:BENEFICIAL_OWNER_OF|SHAREHOLDER_IN|SUBSIDIARY_OF*1..5]->(m) RETURN path',
    params: [{ name: 'name', label: 'Starting Entity', placeholder: 'e.g., Viktor Petrov', type: 'node_name' }],
  },
  {
    id: 'shell-companies',
    name: 'Find Shell Companies',
    description: 'Find companies with nominee directors (directors on 3+ boards)',
    cypher: 'MATCH (d:Person)-[:DIRECTOR_OF]->(c:Company) WITH d, collect(c) AS companies WHERE size(companies) >= $min_boards RETURN d.name AS nominee, [c IN companies | c.name] AS companies, size(companies) AS board_count ORDER BY board_count DESC',
    params: [{ name: 'min_boards', label: 'Minimum Boards', placeholder: '3', type: 'number' }],
  },
  {
    id: 'all-relationships',
    name: 'All Relationships for Entity',
    description: 'Show all incoming and outgoing relationships for a named entity',
    cypher: 'MATCH (n {name: $name})-[r]-(m) RETURN n, type(r) AS relationship, m',
    params: [{ name: 'name', label: 'Entity Name', placeholder: 'e.g., Volkov Foundation', type: 'node_name' }],
  },
];
